import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Paper,
  Grid,
  CircularProgress,
  Snackbar,
  Alert,
  Divider,
} from "@mui/material";
import {
  Close as CloseIcon,
  ShoppingBagOutlined,
  LocationOnOutlined,
  HelpOutline,
  Logout,
  ChevronRight,
  EditOutlined,
  HomeOutlined,
  PersonRounded,
  EmailOutlined,
  PhoneOutlined,
  CalendarTodayOutlined,
  BusinessOutlined,
  SecurityOutlined,
  WalletOutlined,
  LoyaltyOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearPincode } from "../../redux/slices/orderSlice";
import { logout as logoutAction, setUser } from "../../redux/slices/authSlice";
import MyOrdersDrawer from "../../pages/MyOrder/myorder";
import AddressDrawer from "../AddressManagement/AddressManagement";
import { SignOut } from "../../services/api/authService";
import WalletDrawer from "../Wallet/Wallet"

const GOLD = "#ecd49a";
const NAVY = "#152d55";

const getInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(" ");
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : name.substring(0, 2).toUpperCase();
};

const ConsumerProfile = ({ open, onClose, onLogout }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get user data from Redux store
  const user = useSelector((state) => state?.auth?.user);
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);
  const zipcode = useSelector((state) => state.orders?.postalcode);
  const refreshToken = localStorage.getItem("refreshToken");
  console.log("refreshToken in Header:", refreshToken);

  const [editOpen, setEditOpen] = useState(false);
  const [addrOpen, setAddrOpen] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [loadingAddr, setLoadingAddr] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: "", sev: "success" });
  const [ordersDrawerOpen, setOrdersDrawerOpen] = useState(false);
  const [addressDrawerOpen, setAddressDrawerOpen] = useState(false);
  const [walletOpen,setWalletOpen]= useState(false)

  // Initialize profile with Redux user data
  const [profile, setProfile] = useState({
    name: user?.name || "",
    email: user?.email || "",
    phone: user?.phoneNumber || user?.phone || "",
    dob: user?.dob || "",
    gender: user?.gender || "",
    businessName: user?.businessName || "",
    accountType: user?.accountType || "personal",
    gstin: user?.gstin || "",
    ageGroup: user?.ageGroup || "",
  });

  // Update profile when user data changes
  useEffect(() => {
    if (user) {
      setProfile({
        name: user.name || "",
        email: user.email || "",
        phone: user.phoneNumber || user.phone || "",
        dob: user.dob || "",
        gender: user.gender || "",
        businessName: user.businessName || "",
        accountType: user.accountType || "personal",
        gstin: user.gstin || "",
        ageGroup: user.ageGroup || "",
      });
    }
  }, [user]);

  const handleSaveProfile = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/user/update-profile`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name: profile.name,
            email: profile.email,
            phoneNumber: profile.phone,
            dob: profile.dob,
            gender: profile.gender,
            businessName: profile.businessName,
            accountType: profile.accountType,
            gstin: profile.gstin,
            ageGroup: profile.ageGroup,
          }),
        },
      );

      if (res.ok) {
        const updatedUser = await res.json();

        // Update Redux store with new user data
        dispatch(setUser(updatedUser.user || updatedUser));

        // Update localStorage
        const stored = localStorage.getItem("user");
        if (stored) {
          const userData = JSON.parse(stored);
          Object.assign(userData, profile);
          localStorage.setItem("user", JSON.stringify(userData));
        }

        setSnack({
          open: true,
          msg: "Profile updated successfully!",
          sev: "success",
        });
        setEditOpen(false);
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      setSnack({ open: true, msg: "Failed to update profile", sev: "error" });
    }
  };

  const handleLogout = () => {
    // Clear Redux state
    SignOut(refreshToken);

    dispatch(logoutAction());
    dispatch(clearPincode());

    // Clear localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userName");
    localStorage.removeItem("userLocation");
    localStorage.removeItem("cart");

    // Clear sessionStorage
    sessionStorage.clear();

    // Call parent logout handler
    if (onLogout) onLogout();

    // Close drawer and navigate to home
    onClose();
    navigate("/");

    setSnack({ open: true, msg: "Logged out successfully!", sev: "success" });

    // Optional: reload to clear all state
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const menuItems = [
    {
      icon: <PersonRounded />,
      label: "Profile Details",
      onClick: () => setEditOpen(true),
      badge: null,
    },
    {
      icon: <ShoppingBagOutlined />,
      label: "My Orders",
      //   onClick: () => { onClose(); navigate("/my-orders"); },
      onClick: () => setOrdersDrawerOpen(true),
      badge: null,
    },
    {
      icon: <LocationOnOutlined />,
      label: "Saved Addresses",
      onClick: () => setAddressDrawerOpen(true),
      badge: addresses.length || null,
    },
    {
      icon: <WalletOutlined />,
      label: "Wallet & Payment",
      onClick: () => setWalletOpen(true),
      badge: addresses.length || null,
    },
     {
      icon: <LoyaltyOutlined />,
      label: "Subscription",
      onClick: () => setWalletOpen(true),
      badge: addresses.length || null,
    },
    // {
    //   icon: <HelpOutline />,
    //   label: "Help & Support",
    //   onClick: () => {
    //     onClose();
    //     navigate("/help");
    //   },
    //   badge: null,
    // },
  ];

  const fieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      bgcolor: "#ecd49a",
      border: "1.5px solid rgba(0,31,84,0.1)",
      "& fieldset": { borderColor: "#ecd49a" },
      "&:hover fieldset": { borderColor: NAVY },
      "&.Mui-focused fieldset": { borderColor: NAVY },
    },
    "& .MuiInputLabel-root.Mui-focused": { color: NAVY },
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 380 },
            bgcolor: GOLD,
            borderRadius: { xs: 0, sm: "20px 0 0 20px" },
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        {/* Header Section */}
        <Box sx={{ bgcolor: NAVY, px: 3, pb: 3.5, position: "relative" }}>
          {/* Close button */}
          <Box
            sx={{ display: "flex", pt: 2, justifyContent: "flex-end", mb: 2.5 }}
          >
            <IconButton
              onClick={onClose}
              size="small"
              sx={{
                color: NAVY,
                bgcolor: "#e8c97a",
                "&:hover": { bgcolor: "#d4b86a" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Avatar and basic info */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              sx={{
                width: 70,
                height: 70,
                bgcolor: GOLD,
                color: NAVY,
                fontSize: 28,
                fontWeight: 800,
                fontFamily: "'Playfair Display', serif",
                flexShrink: 0,
                border: "3px solid rgba(243,222,159,0.5)",
              }}
            >
              {getInitials(profile.name)}
            </Avatar>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 18,
                  fontFamily: "'Playfair Display', serif",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {profile.name || "Hello there"}
              </Typography>
              <Typography
                sx={{ color: GOLD, fontSize: 12, opacity: 0.85, mt: 0.3 }}
              >
                {profile.email || "Add your email"}
              </Typography>
              {profile.phone && (
                <Typography
                  sx={{ color: "rgba(243,222,159,0.6)", fontSize: 11, mt: 0.2 }}
                >
                  {profile.phone}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

        {/* Wave connector */}
        <Box sx={{ bgcolor: NAVY, height: 18 }}>
          <Box
            sx={{
              height: "100%",
              bgcolor: GOLD,
              clipPath: "ellipse(100% 97% at 50% 0%)",
            }}
          />
        </Box>

        {/* Menu Items */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 2,
            pt: 1,
            "&::-webkit-scrollbar": { width: 0 },
          }}
        >
          {menuItems.map((item, i) => (
            <Box
              key={i}
              onClick={item.onClick}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 2,
                py: 1.6,
                mb: 1,
                borderRadius: 3,
                cursor: "pointer",
                bgcolor: "rgba(0,31,84,0.06)",
                border: "1.5px solid rgba(0,31,84,0.08)",
                transition: "all 0.18s ease",
                animation: `fadeUp 0.35s ease both`,
                animationDelay: `${i * 60}ms`,
                "@keyframes fadeUp": {
                  from: { opacity: 0, transform: "translateY(10px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
                "&:hover": {
                  bgcolor: NAVY,
                  borderColor: NAVY,
                  "& .label": { color: GOLD },
                  "& .icon": { color: GOLD },
                  "& .arrow": { color: GOLD, transform: "translateX(3px)" },
                },
              }}
            >
              <Box
                className="icon"
                sx={{
                  color: NAVY,
                  transition: "color 0.18s",
                  "& svg": { fontSize: 22 },
                }}
              >
                {item.icon}
              </Box>
              <Typography
                className="label"
                sx={{
                  flex: 1,
                  fontWeight: 600,
                  fontSize: 14,
                  color: NAVY,
                  fontFamily: "'DM Sans', sans-serif",
                  transition: "color 0.18s",
                }}
              >
                {item.label}
              </Typography>
              {item.badge ? (
                <Chip
                  label={item.badge}
                  size="small"
                  sx={{
                    bgcolor: NAVY,
                    color: GOLD,
                    fontWeight: 700,
                    fontSize: 10,
                    height: 20,
                  }}
                />
              ) : null}
              <ChevronRight
                className="arrow"
                sx={{
                  color: NAVY,
                  fontSize: 18,
                  opacity: 0.5,
                  transition: "all 0.18s",
                }}
              />
            </Box>
          ))}
        </Box>

        {/* Logout Button */}
        <Box sx={{ px: 2.5, pb: 3, pt: 2 }}>
          <Divider sx={{ borderColor: "rgba(0,31,84,0.15)", mb: 2.5 }} />
          <Button
            fullWidth
            onClick={handleLogout}
            startIcon={<Logout sx={{ fontSize: "18px !important" }} />}
            sx={{
              py: 1.5,
              borderRadius: 3,
              bgcolor: NAVY,
              color: GOLD,
              textTransform: "none",
              fontWeight: 700,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 14,
              letterSpacing: 0.3,
              boxShadow: "0 4px 14px rgba(0,31,84,0.25)",
              "&:hover": {
                bgcolor: "#002b78",
                boxShadow: "0 6px 20px rgba(0,31,84,0.35)",
              },
              transition: "all 0.2s",
            }}
          >
            Logout
          </Button>
        </Box>
      </Drawer>

      {/* Edit Profile Dialog - Enhanced with all fields */}
      <Dialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}
      >
        <Box
          sx={{
            bgcolor: NAVY,
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: GOLD,
              fontWeight: 700,
              fontSize: 18,
              fontFamily: "'Playfair Display', serif",
            }}
          >
            Edit Profile
          </Typography>
          <IconButton
            onClick={() => setEditOpen(false)}
            size="small"
            sx={{ color: GOLD }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent
          sx={{ bgcolor: GOLD, pt: 3, maxHeight: "70vh", overflowY: "auto" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* Basic Information Section */}
            <Typography
              sx={{ color: NAVY, fontWeight: 700, fontSize: 14, mb: 1 }}
            >
              Basic Information
            </Typography>

            <TextField
              label="Full Name"
              value={profile.name}
              onChange={(e) => setProfile({ ...profile, name: e.target.value })}
              variant="outlined"
              fullWidth
              sx={fieldSx}
              InputProps={{
                startAdornment: (
                  <PersonRounded sx={{ mr: 1, color: NAVY, fontSize: 20 }} />
                ),
              }}
            />

            <TextField
              label="Email Address"
              type="email"
              value={profile.email}
              onChange={(e) =>
                setProfile({ ...profile, email: e.target.value })
              }
              variant="outlined"
              fullWidth
              sx={fieldSx}
              InputProps={{
                startAdornment: (
                  <EmailOutlined sx={{ mr: 1, color: NAVY, fontSize: 20 }} />
                ),
              }}
            />

            <TextField
              label="Phone Number"
              type="tel"
              value={profile.phone}
              onChange={(e) =>
                setProfile({ ...profile, phone: e.target.value })
              }
              variant="outlined"
              fullWidth
              sx={fieldSx}
              InputProps={{
                startAdornment: (
                  <PhoneOutlined sx={{ mr: 1, color: NAVY, fontSize: 20 }} />
                ),
              }}
            />

            {/* Personal Details Section */}
            <Typography
              sx={{ color: NAVY, fontWeight: 700, fontSize: 14, mt: 2, mb: 1 }}
            >
              Personal Details
            </Typography>

            <TextField
              label="Date of Birth"
              type="date"
              value={profile.dob || ""}
              onChange={(e) => setProfile({ ...profile, dob: e.target.value })}
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={fieldSx}
              InputProps={{
                startAdornment: (
                  <CalendarTodayOutlined
                    sx={{ mr: 1, color: NAVY, fontSize: 20 }}
                  />
                ),
              }}
            />

            <TextField
              select
              label="Gender"
              value={profile.gender || ""}
              onChange={(e) =>
                setProfile({ ...profile, gender: e.target.value })
              }
              variant="outlined"
              fullWidth
              sx={fieldSx}
              SelectProps={{ native: true }}
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </TextField>

            {/* <TextField
              select
              label="Age Group"
              value={profile.ageGroup || ""}
              onChange={(e) =>
                setProfile({ ...profile, ageGroup: e.target.value })
              }
              variant="outlined"
              fullWidth
              sx={fieldSx}
              SelectProps={{ native: true }}
            >
              <option value="">Select Age Group</option>
              <option value="under-18">Under 18</option>
              <option value="18-24">18-24</option>
              <option value="25-34">25-34</option>
              <option value="35-44">35-44</option>
              <option value="45-54">45-54</option>
              <option value="55+">55+</option>
            </TextField> */}

            {/* Business Information (shown for business accounts) */}
            {profile.accountType === "business" && (
              <>
                <Typography
                  sx={{
                    color: NAVY,
                    fontWeight: 700,
                    fontSize: 14,
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Business Information
                </Typography>

                <TextField
                  label="Business Name"
                  value={profile.businessName || ""}
                  onChange={(e) =>
                    setProfile({ ...profile, businessName: e.target.value })
                  }
                  variant="outlined"
                  fullWidth
                  sx={fieldSx}
                  InputProps={{
                    startAdornment: (
                      <BusinessOutlined
                        sx={{ mr: 1, color: NAVY, fontSize: 20 }}
                      />
                    ),
                  }}
                />

                <TextField
                  label="GSTIN"
                  value={profile.gstin || ""}
                  onChange={(e) =>
                    setProfile({ ...profile, gstin: e.target.value })
                  }
                  variant="outlined"
                  fullWidth
                  sx={fieldSx}
                  InputProps={{
                    startAdornment: (
                      <SecurityOutlined
                        sx={{ mr: 1, color: NAVY, fontSize: 20 }}
                      />
                    ),
                  }}
                />
              </>
            )}

            {/* Account Type Display */}
            <TextField
              label="Account Type"
              value={
                profile.accountType === "business"
                  ? "Business Account"
                  : "Personal Account"
              }
              variant="outlined"
              fullWidth
              disabled
              sx={fieldSx}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ bgcolor: GOLD, px: 3, pb: 2.5, pt: 0, gap: 1 }}>
          <Button
            onClick={() => setEditOpen(false)}
            sx={{ color: NAVY, textTransform: "none", fontWeight: 600 }}
          >
            Cancel
          </Button>
          {/* <Button 
            onClick={handleSaveProfile} 
            variant="contained"
            sx={{ 
              bgcolor: NAVY, 
              color: GOLD, 
              textTransform: "none", 
              fontWeight: 700, 
              borderRadius: 2, 
              px: 3,
              "&:hover": { bgcolor: "#002b78" } 
            }}
          >
            Save Changes
          </Button> */}
        </DialogActions>
      </Dialog>

      {/* Addresses Dialog */}
      <Dialog
        open={addrOpen}
        onClose={() => setAddrOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}
      >
        <Box
          sx={{
            bgcolor: NAVY,
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: GOLD,
              fontWeight: 700,
              fontSize: 18,
              fontFamily: "'Playfair Display', serif",
            }}
          >
            Saved Addresses
          </Typography>
          <IconButton
            onClick={() => setAddrOpen(false)}
            size="small"
            sx={{ color: GOLD }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent sx={{ bgcolor: GOLD }}>
          {loadingAddr ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
              <CircularProgress sx={{ color: NAVY }} />
            </Box>
          ) : addresses.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 5 }}>
              <LocationOnOutlined
                sx={{ fontSize: 48, color: NAVY, opacity: 0.3, mb: 1 }}
              />
              <Typography sx={{ color: NAVY, opacity: 0.6, mb: 2 }}>
                No saved addresses
              </Typography>
              <Button
                variant="contained"
                onClick={() => {
                  setAddrOpen(false);
                  onClose();
                }}
                sx={{
                  bgcolor: NAVY,
                  color: GOLD,
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: 2,
                }}
              >
                + Add Address
              </Button>
            </Box>
          ) : (
            <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
              {addresses.map((addr, i) => (
                <Grid item xs={12} key={i}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      bgcolor: "#fff",
                      border: "1.5px solid rgba(0,31,84,0.1)",
                      display: "flex",
                      gap: 1.5,
                      alignItems: "flex-start",
                    }}
                  >
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: 2,
                        bgcolor: NAVY,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <HomeOutlined sx={{ color: GOLD, fontSize: 18 }} />
                    </Box>
                    <Box>
                      <Typography
                        sx={{ color: NAVY, fontWeight: 700, fontSize: 13 }}
                      >
                        {addr.type || "Home"}
                      </Typography>
                      <Typography sx={{ color: "#555", fontSize: 12, mt: 0.3 }}>
                        {addr.street}, {addr.city}, {addr.state} –{" "}
                        {addr.pincode}
                      </Typography>
                      {addr.phone && (
                        <Typography
                          sx={{ color: "#888", fontSize: 11, mt: 0.4 }}
                        >
                          📞 {addr.phone}
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </DialogContent>
      </Dialog>
      <MyOrdersDrawer
        open={ordersDrawerOpen}
        onClose={() => setOrdersDrawerOpen(false)}
      />
      <AddressDrawer
        open={addressDrawerOpen}
        onClose={() => setAddressDrawerOpen(false)}
        // onAddressSelect={handleAddressSelect}
        // selectedAddressId={selectedAddressId}
        userId={user?.uuid}
        zipcode={zipcode}
      />
        <WalletDrawer
        open={walletOpen}
        onClose={() => setWalletOpen(false)}
        userId={user?.userId}
      />

      {/* Snackbar for notifications */}
      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snack.sev} sx={{ width: "100%" }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConsumerProfile;
